export default __webpack_public_path__ + "static/media/play-icon.168ad30a.jpg";